

























































import Vue from 'vue';
import { mapGetters } from 'vuex';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import { confirmationHelper, TabsHelper } from '@/mixins';
import { FormFieldValidation } from '@/mixins/formValidation';
import { DocumentRetentionModel, RetentionType } from '@/services/GeneratedApi';
import { EnumUtils } from '@/utils';
import ApiConfiguration from '@/classes/ApiConfiguration';
import MStoreFormSelect from '@/components/shared/MStoreFormSelect.vue';
import MStoreFormDatePicker from '@/components/shared/MStoreFormDatePicker.vue';
import Toast from '@/classes/SnotifyConfiguration';

export default Vue.extend({
  name: 'MStoreRetentionTab',
  mixins: [FormFieldValidation, confirmationHelper, TabsHelper],
  props: {
    documentId: {
      type: Number,
      required: true
    },
    cabinetId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isLoading: false,
      isUpdating: false,
      documentInformationModel: {} as DocumentRetentionModel,
      isUserAdmin: false,
      userCanEditForDocType: false,
      formIsValid: true
    };
  },
  async mounted() {
    await this.getDocumentRetentionInformation();
  },
  created(this: any) {
    this.retentionActionTypes = EnumUtils.getEnumValues(RetentionType);
  },
  methods: {
    async getDocumentRetentionInformation(this: any) {
      this.isLoading = true;
      this.documentInformationModel = await ApiConfiguration.api()
        .document.documentRetentionInformationList({ CabinetId: this.documentSearchModel.cabinetId, DocumentId: this.documentSearchModel.documentId })
        .catch((reason: any) => {
          return {
            notification: reason.response.data,
            hasNotification: true
          } as DocumentRetentionModel;
        });
      this.isLoading = false;
    },
    async updateRetentionAsync(this: any) {
      this.isUpdating = true;
      try {
        await ApiConfiguration.api().document.documentUpdateRetentionUpdate({
          CabinetId: this.documentSearchModel.cabinetId,
          DocumentId: this.documentSearchModel.documentId,
          RetentionType: this.documentInformationModel.retentionType,
          RetentionDate: this.documentInformationModel.retentionDate
        });
        Toast.showSuccess('Retention updated successfully!');
        this.setApplicationDirty(false);
      } catch {
        Toast.showError('An error occured updating retention.');
      } finally {
        this.isUpdating = false;
      }
    },
    async onSubmit(this: any) {
      const isDateValid = this.retentionDateIsValid();
      if (!isDateValid) {
        return;
      }

      const isValid = await this.validateFormAsync('retentionForm');
      if (isValid) {
        await this.updateRetentionAsync();
      }
    },
    updateDate(this: any, newValue: string) {
      this.formIsValid = this.retentionDateIsValid(newValue);
    },
    retentionDateIsValid(this: any, value?: string) {
      const dateValue = value ? new Date(value) : this.retentionDate ? new Date(this.retentionDate) : null;
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      let isValid = true;
      let errorMsg = '';

      if (!dateValue) {
        isValid = false;
        errorMsg = 'A retention date is required.';
      } else {
        // Must be strictly in the future (not today)
        if (dateValue <= today) {
          isValid = false;
          errorMsg = 'The retention date must be set in the future.';
        }
      }

      this.$validator.errors.remove('retentionDateValidationErrors');

      if (!isValid) {
        this.$validator.errors.add({
          field: 'retentionDateValidationErrors',
          msg: errorMsg
        });
      }

      return isValid;
    }
  },
  computed: {
    ...mapGetters('userStore', ['isUserAdministrator']),
    ...mapGetters('documentViewStore', ['documentSearchModel']),
    isDisabled(this: any) {
      return this.isLoading || this.isUpdating;
    },
    retentionDate: {
      get(this: any) {
        return this.documentInformationModel.retentionDate;
      },
      set(this: any, value: string) {
        this.documentInformationModel.retentionDate = value;
        this.setApplicationDirty(true);
      }
    },
    retentionType: {
      get(this: any) {
        return this.documentInformationModel.retentionType;
      },
      set(this: any, value: RetentionType) {
        this.documentInformationModel.retentionType = value;
        this.setApplicationDirty(true);
      }
    }
  },
  components: {
    LoadingSpinner,
    MStoreFormSelect,
    MStoreFormDatePicker
  }
});
